import { useTranslation } from 'react-i18next'
import { CheckCircle, XCircle, LogOut, Pause } from 'lucide-react'
import { Badge } from '@quebon/ui/components/badge'
import type { RosterAttendanceStatus } from '@/types/coaching'
import { displayAttendanceStatus } from '@/utils/attendanceDisplay'

const states = {
  IN: { icon: CheckCircle, variant: 'default' },
  OUT: { icon: LogOut, variant: 'secondary' },
  ABSENT: { icon: XCircle, variant: 'destructive' },
  LEAVE: { icon: Pause, variant: 'secondary' },
} as const

export function HandheldAttendanceBadge({ status }: { status: RosterAttendanceStatus }) {
  const { t } = useTranslation('learner')
  const shown = displayAttendanceStatus(status)
  const { icon: Icon, variant } = states[shown]
  const label = t(`attendance.status.${shown}`)
  return <Badge variant={variant} className="h-7 gap-1.5 px-3" role="status" aria-label={label}>
    <Icon data-icon="inline-start" aria-hidden="true" />{label}
  </Badge>
}
